import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { Settings } from '../../shared/icons';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { Position, PositionModal } from '../../shared/modal/PositionModal';
import styles from './Analytics.module.scss';
import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { getIncludePreExecutionAnalytics, getShowOverrideRiskRating, toggleShouldIncludePreExecutionAnalytics, toggleShowOverrideRiskRating } from './store';
import { Toggle } from '../../shared/toggle';

interface AnalyticsConfigModalProps {
    closeModal: () => void;
    position: Position | null;
    width: number;
}

export const AnalyticsConfigModal: React.FC<AnalyticsConfigModalProps> = ({ closeModal, position, width }) => {
    const dispatch = useAppDispatch();
    const showOverrideRiskRating = useAppSelector(getShowOverrideRiskRating);
    const includePreExecutionAnalytics = useAppSelector(getIncludePreExecutionAnalytics);

    const toggleOverride = useCallback(() => dispatch(toggleShowOverrideRiskRating()), [dispatch]);
    const toggleIncludePreExecution = useCallback(() => dispatch(toggleShouldIncludePreExecutionAnalytics()), [dispatch]);

    if (isNull(position)) {
        return null;
    }

    return (
        <PositionModal
            isOpen
            testId='document-analytics-settings'
            closeModal={closeModal}
            position={position}
            height='fit-content'
            width={`${width}px`}
        >
            <div className={styles.analyticsConfigModal}>
                <ModalHeader icon={Settings} label='Settings' iconSize={30} />
                <div className={styles.analyticsConfig}>
                    <div className={styles.configSectionWrapper}>
                        <div className={styles.configSectionTitle}>Risk Tolerance</div>
                        <div className={styles.configWrapper}>
                            <div className={styles.configLabel}>Include Client Overrides</div>
                            <Toggle onChange={toggleOverride} checked={showOverrideRiskRating} />
                        </div>
                        <div className={styles.configWrapper}>
                            <div className={styles.configLabel}>Include Pre Execution Documents</div>
                            <Toggle onChange={toggleIncludePreExecution} checked={includePreExecutionAnalytics} />
                        </div>
                    </div>
                </div>
            </div>
        </PositionModal>
    );
};
